import { Link, useNavigate } from "react-router-dom";
import "../../../../utils/Css/employeelist.css";
import BootstrapTable from "react-bootstrap-table-next";
import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import moment from "moment";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import {
  deleteEmployee,
  getEmployees,
  updateEmployee,
} from "../../../../services/RHService/EmployeeService";

import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import filterFactory from "react-bootstrap-table2-filter";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../../components/layouts/WithLoader";

const EmployeeList = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const { ExportCSVButton } = CSVExport;
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  //afficher les information par defaut dans le Model
  const handleShow = (employee) => {
    setSelectedEmployee(employee);
    setShow(true);
  };
  const MyExportCSV = (props) => {
    const handleClick = () => {
      props.onExport();
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleClick}>
          <i class="fas fa-download"></i> Télécharger CSV
        </button>
      </div>
    );
  };
  const onUploadExcel = () => {
    navigate(`/uploadEmployeExcel`);
  };
  const goFicheEmployee = (idEmploye) => {
    localStorage.setItem("idEmployeFiche", idEmploye);
    const pdfWindow = window.open();
    pdfWindow.location.href = "/ficheEmployee";
   
    // navigate("/ficheEmployee");
  };
  const fetchData = () => {
    startLoading();
    getEmployees(getCurrentUserId())
      .then((responseEmployeeList) => {
        if (responseEmployeeList) {
          setEmployees(responseEmployeeList.data.success);
          stopLoading();
        } else {
          console.error("Data or data.success is undefined");
        }
      })
      .catch((error) => {
        console.error("Error " + error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  // filtrage par date recrutement et assurance vie
  const [isassuredFilter, setIsassuredFilter] = useState(false);
  const [formData, setFormData] = useState({});
  const { SearchBar } = Search;

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "isassured") {
      setIsassuredFilter(value);
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const filteredData = employees.filter((emp) => {
    if (
      (isassuredFilter && !emp.isAssured) ||
      (formData.dateDeb &&
        new Date(emp.dateRec) < new Date(formData.dateDeb)) ||
      (formData.dateFin && new Date(emp.dateRec) > new Date(formData.dateFin))
    ) {
      return false;
    }
    return true;
  });

  //pagination
  const options = {
    sizePerPage: 5,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  // archiver employee
  const handleDelete = async (employeeID) => {
    await deleteEmployee(employeeID, setEmployees);
  };

  //update employee
  const handleUpdate = async (event) => {
    event.preventDefault();
    // Convert date format to "YYYY-MM-DD"
    const { dateNais, dateRec, ...otherFormData } = selectedEmployee;
    const formattedFormData = {
      ...otherFormData,
      dateNais: moment(selectedEmployee.dateNais).format("YYYY-MM-DD"),
      dateRec: moment(selectedEmployee.dateRec).format("YYYY-MM-DD"),
    };

    // Vérifier si les champs sont renseignés
    if (
      formattedFormData.email === "" ||
      formattedFormData.cin === "" ||
      formattedFormData.adr === "" ||
      formattedFormData.country === "" ||
      formattedFormData.firstName === "" ||
      formattedFormData.lastName === "" ||
      formattedFormData.numCnss === "" ||
      formattedFormData.phoneNumber === "" ||
      formattedFormData.postalCode === 0
    ) {
      toastr.error("Veuillez renseigner tous les champs.");
    } else {
      if (
        formattedFormData.phoneNumber.length === 8 &&
        /^\d+$/.test(formattedFormData.phoneNumber)
      ) {
        if (
          formattedFormData.cin.length === 8 &&
          /^\d+$/.test(formattedFormData.cin)
        ) {
          if (/^\d+$/.test(formattedFormData.postalCode)) {
            if (/\S+@\S+\.\S+/.test(formattedFormData.email)) {
              try {
                console.log(formattedFormData.id);
                console.log(formattedFormData);

                await updateEmployee(formattedFormData.id, formattedFormData);
                fetchData();
                handleClose();
              } catch (error) {
                alert(error.message);
              }
            } else {
              // Do something if the phone number is invalid
              toastr.error("Email invalide");
            }
          } else {
            // Do something if the phone number is invalid
            toastr.error("Code Postal invalide : 4 Chiffres");
          }
        } else {
          // Do something if the phone number is invalid
          toastr.error("Numéro de carte d'identité invalide : 8 Chiffres");
        }
      } else {
        // Do something if the phone number is invalid
        toastr.error("Numéro de téléphone invalide : 8 Chiffres");
      }
    }
  };
  //colonnes de table
  const columns = [
    {
      dataField: "matricule",
      text: "Matricule",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "p",
      text: "Nom et prénom",
      formatter: (cell, row) => {
        const { firstName, lastName } = row;
        const fullName = `${firstName || "-"} ${lastName || "-"}`;
        return fullName;
      },
      headerAlign: "center",
      headerStyle: () => {
        return { width: "20%" };
      },
    },
    {
      dataField: "cin",
      text: "Cin",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      dataField: "email",
      text: "Email",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    { dataField: "phoneNumber", text: "N° Téléphone", headerAlign: "center" },
    { dataField: "numCnss", text: "N. CNSS", headerAlign: "center" },
    {
      dataField: "isAssured",
      text: "A.vie",
      headerStyle: { width: "100px" },
      headerAlign: "center",
      align: "center",

      formatter: (cell, row) => {
        const badgeClass = row.isAssured ? "fa-check" : "fa-xmark";
        return (
          <div className="center">
            <i className={`fa-solid ${badgeClass}`}></i>
          </div>
        );
      },
    },
    {
      dataField: "dateRec",
      text: "D.Recrutement",
      headerAlign: "center",

      formatter: (cell, row) => {
        return cell || "-";
      },
      style: { textAlign: "center" },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerStyle: { width: "170px" },
      headerAlign: "center",

      csvExport: false,
      formatter: (cell, row) => {
        return (
          <div className="center" style={{ display: "flex" }}>
            <div className="row">
              <div className="col-sm-4">
                <button
                  style={{ width: 40 }}
                  class="btn bg-black btn-sm "
                  onClick={() => handleShow(row)}
                >
                  <i class="fa-solid fa-pencil"></i>
                </button>
              </div>
              <div className="col-sm-4">
                <button
                  style={{ width: 40 }}
                  class="btn bg-dark btn-sm "
                  onClick={() => goFicheEmployee(row.id)}
                >
                  <i
                    class="fa-solid fa-eye eye-icon m-1"
                    style={{ color: "white" }}
                  ></i>{" "}
                </button>
              </div>
              <div className="col-sm-4">
                <button
                  style={{ width: 40 }}
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(row.id)}
                >
                  <i className="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <ToolkitProvider
        keyField="id"
        data={filteredData}
        columns={columns}
        exportCSV={{
          fileName: "List Personnels.csv",
          onlyExportFiltered: true,
          exportAll: false,
        }}
        search
      >
        {(props) => (
          <div>
            {/* Modify employee Modal */}
            <Modal show={show} onHide={handleClose} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>Modifier les informations</Modal.Title>
              </Modal.Header>
              <Modal.Body className="show-grid">
                <Form onSubmit={handleUpdate}>
                  <Container>
                    <Row>
                      <Col xs={12} md={4}>
                        <Form.Group className="form-group">
                          <Form.Label>Genre</Form.Label>
                          <select
                            className="custom-select form-control-border"
                            name="gender"
                            value={
                              selectedEmployee && selectedEmployee.gender
                                ? selectedEmployee.gender
                                : "homme"
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                gender: e.target.value,
                              })
                            }
                          >
                            <option value="femme">Femme</option>
                            <option value="homme">Homme</option>
                          </select>
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Nom</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="Nom"
                            autoFocus
                            name="firstName"
                            value={
                              selectedEmployee ? selectedEmployee.firstName : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                firstName: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Prenom</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="Prenom"
                            autoFocus
                            name="lastName"
                            value={
                              selectedEmployee ? selectedEmployee.lastName : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                lastName: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="email"
                            placeholder="name@example.com"
                            autoFocus
                            name="email"
                            value={
                              selectedEmployee ? selectedEmployee.email : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                email: e.target.value,
                              })
                            }
                          />
                        </Form.Group>

                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Telephone</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="Telephone"
                            autoFocus
                            name="phone"
                            value={
                              selectedEmployee
                                ? selectedEmployee.phoneNumber
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                phoneNumber: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6} md={4}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>CIN</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="CIN"
                            autoFocus
                            name="cin"
                            value={selectedEmployee ? selectedEmployee.cin : ""}
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                cin: e.target.value,
                              })
                            }
                          />
                        </Form.Group>

                        <div className="form-group">
                          <label>Date de naissance:</label>
                          <div
                            className="input-group date"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              name="dateNais"
                              defaultValue={
                                selectedEmployee
                                  ? selectedEmployee.dateNais
                                  : ""
                              }
                              onChange={(e) =>
                                setSelectedEmployee({
                                  ...selectedEmployee,
                                  dateNais: e.target.value,
                                })
                              }
                              className="form-control form-control-border"
                            />
                          </div>
                        </div>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Adresse</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="type"
                            placeholder="Adresse"
                            autoFocus
                            name="adr"
                            value={selectedEmployee ? selectedEmployee.adr : ""}
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                adr: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Code Postal</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="Code Postal"
                            autoFocus
                            name="postalCode"
                            value={
                              selectedEmployee
                                ? selectedEmployee.postalCode
                                : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                postalCode: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Ville</Form.Label>
                          <Form.Control
                            className="form-control form-control-border"
                            type="text"
                            placeholder="Ville"
                            autoFocus
                            name="country"
                            value={
                              selectedEmployee ? selectedEmployee.country : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                country: e.target.value,
                              })
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col xs={6} md={4}>
                        <div className="form-group">
                          <label>Date recrutement:</label>
                          <div
                            className="input-group date"
                            id="reservationdate"
                            data-target-input="nearest"
                          >
                            <input
                              type="date"
                              value={
                                selectedEmployee ? selectedEmployee.dateRec : ""
                              }
                              name="dateRec"
                              onChange={(e) =>
                                setSelectedEmployee({
                                  ...selectedEmployee,
                                  dateRec: e.target.value,
                                })
                              }
                              className="form-control form-control-border "
                            />
                          </div>
                        </div>
                        <div className="form-group">
                          <label for="exampleInputPassword1">Numéro CNSS</label>
                          <input
                            type="text"
                            name="numcnss"
                            value={
                              selectedEmployee ? selectedEmployee.numCnss : ""
                            }
                            onChange={(e) =>
                              setSelectedEmployee({
                                ...selectedEmployee,
                                numCnss: e.target.value,
                              })
                            }
                            className="form-control form-control-border"
                            placeholder="Numéro CNSS"
                          />
                        </div>
                        <div class="form-group">
                          <div className="custom-control custom-checkbox mt-5">
                            <input
                              className="custom-control-input custom-control-input-dark"
                              checked={
                                selectedEmployee && selectedEmployee.isAssured
                              }
                              onChange={(e) =>
                                setSelectedEmployee({
                                  ...selectedEmployee,
                                  isAssured: !!e.target.checked,
                                })
                              }
                              type="checkbox"
                              name="isAssured"
                              id="customCheckbox7"
                            />
                            <label
                              for="customCheckbox7"
                              className="custom-control-label"
                            >
                              Assurance vie
                            </label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  Fermer
                </Button>
                <Button variant="dark" onClick={handleUpdate}>
                  Modifier
                </Button>
              </Modal.Footer>
            </Modal>
            <br />
            <section className="content ">
              <div class="container-fluid">
                <div class="card  mt-3">
                  <div class="card-body">
                    <h5 class="card-title">
                      Importer les employés via un fichier Excel
                    </h5>
                    <button
                      class="btn btn-dark float-right"
                      onClick={onUploadExcel}
                    >
                      <i class="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
                <div class="card card-dark">
                  <div class="card-body">
                    <h5 class="card-title">Ajouter un employé</h5>

                    <Link to="/addemployee">
                      <button class="btn btn-dark  float-right">
                        <i class="fas fa-plus"></i>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </section>
            {/* <section className="content ">
            <div class="container-fluid">
            <div className="card">
              <div className="row">
                <div className="col-md-12 ">
                  <div className="row">
                    <div className="col-md-4 ">
                      <div className="form-group ml-5 mt-2">
                        <label htmlFor="date_rec">Date R. Entre:</label>
                        <input
                          className="form-control"
                          type="date"
                          id="date_rec"
                          name="dateDeb"
                          value={formData.dateDeb}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group ml-5 mt-2">
                        <label htmlFor="date_rec">Et:</label>
                        <input
                          className="form-control"
                          type="date"
                          id="date_rec"
                          name="dateFin"
                          value={formData.dateFin}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-md-4 my-5">
                      <div className="form-group ml-5">
                        <div className="custom-control custom-checkbox ">
                          <input
                            className="custom-control-input custom-control-input-dark"
                            type="checkbox"
                            checked={formData.isassured}
                            onChange={handleInputChange}
                            id="customCheckbox8"
                            name="isassured"
                          />
                          <label
                            for="customCheckbox8"
                            className="custom-control-label"
                          >
                            Assurance vie
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div></section> */}
            <section className="content ">
              <div className="container-fluid">
                <div class="card">
                  <div class="card-header">
                    <h3 class="card-title">Liste des employés</h3>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div>
                        {" "}
                        <SearchBar
                          {...props.searchProps}
                          className="custome-search-field"
                          style={{ color: "black" }}
                          placeholder="Chercher"
                        ></SearchBar>
                      </div>
                      <div className="ml-auto mr-0">
                      <MyExportCSV {...props.csvProps}></MyExportCSV>
                      </div>
                    </div>
                    <div className="row">
                    <BootstrapTable
                      {...props.baseProps}
                      filter={filterFactory()}
                      striped
                      hover
                      condensed
                      pagination={paginationFactory(options)}
                    />
                  </div>
                  </div>
                </div>
                {/* </div> */}
              </div>
            </section>
          </div>
          // </div>
        )}
      </ToolkitProvider>
    </div>
  );
};

export default withLoader(EmployeeList);
